<template>
  <div class="container" @click="closeReason">
    <van-nav-bar :title="$t('withdraw.with_record')">
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="20"  @click="back()"></van-icon>
      </template>
    </van-nav-bar>

    
    <div class="rows" id="content" @scroll="closeReason">
      <div class="row" v-for="(item, index) in recordList" :key="index">
        <div class="left">
          <div class="title">{{ $t('withdraw.money') }}: {{changeMoney(item.money)}}</div>
          <div class="time">{{ item.create_time }}</div>
        </div>
        <div class="right">
          <span>{{ item.status_text }}</span>
          <!-- 失败订单：问号，点击展开失败原因 -->
          <van-icon
            v-if="item.reason"
            name="question-o"
            class="q-icon"
            :class="{ active: activeReason === index }"
            @click.stop="toggleReason(index, $event)"
          />
        </div>
      </div>
    </div>

    <!-- 失败原因气泡：fixed 定位（不会被列表滚动容器裁掉） -->
    <div v-if="reasonBox.show" ref="reasonBox" class="reason-pop-fixed" :style="reasonBox.style">{{ reasonBox.text }}</div>
  </div>
</template>

<script>
import { changeMoney } from '@/common/function';

export default {
  data() {
    return {
      recordList: [],
      activeReason: null,      // 当前展开原因的行下标
      reasonBox: {             // 失败原因气泡
        show: false,
        text: '',
        style: {},
      },
    };
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getRechargeRecord();
    }
    
  },
  methods: {
    back(){
      return window.history.back();
    },
    // 点击问号：展开/收起该行失败原因（再点收起；点其他行切换）
    toggleReason(index, ev) {
      if (this.activeReason === index) {
        return this.closeReason();
      }
      const item = this.recordList[index];
      if (!item || !item.reason) {
        return;
      }
      const GAP = 8;
      const W = Math.min(300, window.innerWidth - 24);
      const rect = ev && ev.currentTarget ? ev.currentTarget.getBoundingClientRect() : null;
      const left = rect
        ? Math.min(Math.max(rect.left + rect.width / 2 - W / 2, 12), window.innerWidth - W - 12)
        : 12;
      const top = rect ? rect.bottom + GAP : 80;

      this.activeReason = index;
      this.reasonBox = { show: true, text: item.reason, style: { left: left + 'px', top: top + 'px', width: W + 'px' } };

      // 渲染后按真实高度微调：下方放不下就翻到问号上方
      this.$nextTick(() => {
        const node = this.$refs.reasonBox;
        if (!node || !rect) {
          return;
        }
        const h = node.getBoundingClientRect().height;
        let finalTop = rect.bottom + GAP;
        if (finalTop + h > window.innerHeight - 12) {
          finalTop = Math.max(12, rect.top - GAP - h);
        }
        this.reasonBox = { show: true, text: item.reason, style: { left: left + 'px', top: finalTop + 'px', width: W + 'px' } };
      });
    },
    closeReason() {
      this.activeReason = null;
      this.reasonBox = { show: false, text: '', style: {} };
    },
    getRechargeRecord(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res=>{
        if(res.code === 200){
          console.log(res.data)
          this.recordList = res.data;
          this.closeReason();
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.container {
  min-height: 100%;
  background: linear-gradient(180deg, #fff5f8 0%, #f8f3ff 55%, #fff6f0 100%);
}
.van-nav-bar {
  height: 2.88rem;

  /deep/ .van-nav-bar__title{
    color: #fff;
    font-size: 1rem;
  }
  /deep/ .van-nav-bar__left{
    padding: 0 1rem;
  }
}

.rows{
  margin-bottom: 1.5625rem;
  .row{
    display: flex;
    padding: 0.63rem 1.00rem;
    position: relative;
    &::before{
      position: absolute;
      content: "";
      border: none;
      width: 90%;
      height: 0.06rem;
      background: linear-gradient(90deg, rgba(80, 59, 143, .15), rgba(80, 59, 143, .61), rgba(80, 59, 143, .15));
      bottom: 0;
    }
    >div{
      flex: 1;
      height: 2.88rem;
    }
    .left{
      display: flex;
      justify-content: space-around;
      flex-direction: column;
    }
    .right{
      display: flex;
      align-items: center;
      color: #ff0000;
      font-size: 0.88rem;
      justify-content: flex-end;

      .q-icon{
        margin-left: 0.31rem;
        font-size: 0.94rem;
        color: #999;

        &.active{
          color: #49328b;
        }
      }
    }
    .title{
      font-size: 0.88rem;
      color: #49328b;
    }
    .time{
      font-size: 0.75rem;
      color: #969799;
      margin-top: 0.25rem;
    }
  }
}

/* 失败原因气泡（点击问号展开，fixed 定位不受列表滚动限制） */
.reason-pop-fixed{
  position: fixed;
  z-index: 3000;
  padding: 0.63rem 0.75rem;
  background: rgba(0, 0, 0, .85);
  color: #fff;
  font-size: 0.81rem;
  line-height: 1.35;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  border-radius: 0.25rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .25);
}
</style>
